import React from "react";
import { Checkbox, Space } from "antd";
import translate from "../../../../i18n/translate";

export default function SaleRoomCount({ searchParams, setSearchParams }) {
  return (
    <div className="filter-card">
      <p>{translate("filter.sale_room_count")}</p>
      <div className="checkbox-container">
        <div>
          <Checkbox
            checked={searchParams.saleRoomCount?.split(",").filter(Boolean).length === 3}
            onClick={() => {
              const allSelected = searchParams.saleRoomCount?.split(",").filter(Boolean).length === 3;
              setSearchParams({
                ...searchParams,
                saleRoomCount: allSelected ? "" : "1+,2+,3+",
              });
            }}
          >
            {translate("filter.all")}
          </Checkbox>
        </div>
        {["1+", "2+", "3+"].map((count) => (
          <div key={count}>
            <Checkbox
              checked={searchParams.saleRoomCount
                ?.split(",")
                .includes(String(count))}
              onClick={(e) => {
                e.target.checked
                  ? setSearchParams({
                      ...searchParams,
                      saleRoomCount: [
                        ...(searchParams.saleRoomCount?.split(",") || []),
                        count,
                      ].join(","),
                    })
                  : setSearchParams({
                      ...searchParams,
                      saleRoomCount: searchParams.saleRoomCount
                        ?.split(",")
                        .filter((currentCount) => count != currentCount)
                        .join(","),
                    });
              }}
            >
              {count}
            </Checkbox>
          </div>
        ))}
      </div>
    </div>
  );
}
